import { defineAction } from '~/prix'
import { z } from 'zod'
import creditDocumentFetchAction from './creditDocumentFetch.action.json' with { type: 'json' }
import { creditDocumentObject } from '../creditDocumentObject'

const creditDocumentFetchDefinition = defineAction({
  ...creditDocumentFetchAction,

  input: z.object({
    id: creditDocumentObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: creditDocumentObject,
})

export default creditDocumentFetchDefinition

